import React from 'react';
import useSiteContent from '../hooks/useSiteContent';
import { siteLinks } from '../content/siteContent';

export default function ConsentPage() {
  const { siteContent } = useSiteContent();

  return (
    <main className="page">
      <section className="page-section page-section--intro">
        <div className="section-heading section-heading--centered">
          <span className="section-heading__eyebrow">{siteContent.consent.tag}</span>
          <h1>{siteContent.consent.title}</h1>
          <p>{siteContent.consent.text}</p>
        </div>
      </section>

      <section className="page-section">
        <div className="card-grid card-grid--3">
          {siteContent.consent.steps.map((step, index) => (
            <div key={step} className="content-card">
              <div className="content-card__body">
                <span className="number-pill">0{index + 1}</span>
                <p>{step}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="page-section split-grid">
        <div className="content-card">
          <div className="content-card__body">
            <h2>{siteContent.consent.documentsTitle}</h2>
            <div className="resource-grid">
              {siteContent.consent.documents.map((item) => (
                <a key={item.href} href={item.href} target="_blank" rel="noopener noreferrer" className="resource-link">
                  {item.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="content-card">
          <div className="content-card__body">
            <h2>{siteContent.contact.infoTitle}</h2>
            <div className="info-list">
              <a href={siteLinks.emailHref}>{siteLinks.email}</a>
              <a href={siteLinks.phoneHref}>{siteLinks.phone}</a>
              <a href={siteLinks.mapsUrl} target="_blank" rel="noopener noreferrer">
                {siteLinks.address1}
                <br />
                {siteLinks.address2}
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
